
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import useOpenInfo from '@/hooks/openInfo'
import stepPercentage from '@/utils/number'
import { openFileView, setApptitle } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { useMutation } from '@vue/apollo-composable'
import { mutateApi } from '@/graphql/mutation'

export default defineComponent({
  setup () {
    const router = useRouter()
    const commomParams = ref()
    const formType = computed(() => storage.get('formType'))
    const { openType, step, title, saveCommonOfVuex } = useOpenInfo()
    const handleNext = () => {
      const percentage = stepPercentage(step)
      commomParams.value = {
        openType: openType.value,
        openStatus: 0,
        btnText: '继续开户',
        remark: `已完成${percentage}%，请继续完善资料`,
        step
      }

      saveClientDraft({
        params: {
          formType: formType.value,
          meta: 'open_common',
          content: JSON.stringify(commomParams.value)
        }
      })
    }

    const { mutate: saveClientDraft, onDone } = useMutation(mutateApi.saveClientFormDraft)
    onDone((res) => {
      const { saveClientFormDraft } = res.data
      if (saveClientFormDraft.ok) {
        saveCommonOfVuex({ info: commomParams.value })
        router.push({ name: 'pi-ar' })
      }
    })

    onMounted(() => {
      setApptitle(title)
    })
    const showPdf = (index: number) => {
      let url = `${process.env.VUE_APP_H5_STATIC_PAGE_URL + '/static_pages/pdf/'}`
      let title
      if (index === 0) {
        url = `${url}SecuritiesaAndFuturesOrdinance.pdf`
        title = '证券及期货条例'
      } else {
        title = '操作守则'
        url = `${url}pg.pdf`
      }
      const params = {
        fileType: 'pdf',
        fileUrl: url,
        title
      }
      openFileView(params)
      // window.open(url);
    }
    return { handleNext, showPdf }
  }
})
